const styles = theme => ({
  dialogPaper: {
    width: "100%",
    maxWidth: 400,
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
  },
  dialogActionsAction: {
    margin: 0,
  },
  placesAutoCompleteInputInput: {
    "&::placeholder": {
      color: "#000",
      opacity: 0.42,
    },
  },
  datePicker: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
})

export default styles
